/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@material-ui/core';
import React from 'react'
import ImageUploading from 'react-images-uploading';
import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@material-ui/core/Button';
import Delete from '@material-ui/icons/Delete';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { useTranslation } from 'react-i18next';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: theme.spacing(5),
        },
        uploadFile:{
            width: '100%',
            background: 'antiquewhite',
            padding: '14px',
            minHeight: '6em',
            marginBottom: '16px',
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 18,
            borderRadius: 8
        },
        changeImage: {
            fontFamily: "Josefin Sans",
            textTransform: "inherit",
            fontSize: 14
        }
    })
);

export const UploadPhotos = (props:{handleChangePhotos:(imageFiles: any)=>void; isUpdating:boolean; selectedPhotos:any;}) => {
    const [images, setImages] = React.useState(props.selectedPhotos);
    const maxNumber = 69;
    const classes = styles();
    const { t } = useTranslation<'common'>(); 

    const removeAllPhotoref:any= React.createRef();
    React.useEffect(() => {
        // Ensure props.selectedPhotos is always an array
        if (props.isUpdating && props.selectedPhotos.length === 0) {
          setImages([]);
        }
      }, [props.selectedPhotos, props.isUpdating]);
    
    const onChange = (imageList:any, addUpdateIndex:any) => {
        setImages(imageList);
        
        props.handleChangePhotos(imageList);
      };
      
    return (
        <>
            <ImageUploading
                multiple
                value={images}
                onChange={onChange}
                maxNumber={maxNumber}
                dataURLKey="data_url">
                {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging, 
                dragProps,
                }) => (
                // write your building UI
                    <div className="upload__image-wrapper">
                        <label htmlFor="contained-button-file">
                            <Button 
                                className={classes.uploadFile}
                                variant="text" 
                                component="span"
                                style={isDragging ? { color: 'red' } : undefined}
                                onClick={onImageUpload}
                                disabled={props.isUpdating }
                                
                                {...dragProps}
                            >
                                
                                <PhotoCamera style={{marginRight: 20}}/> 
                                {t('propriete.labels.photos')}
                            </Button>
                        </label>
                    
                        &nbsp;
                        <Button 
                            style={{'fill': '#d04343', color: '#d04343', textTransform: 'initial'}}
                            onClick={onImageRemoveAll}
                            disabled={props.isUpdating }
                            ref={removeAllPhotoref}
                        >
                            <Delete style={{marginRight: 20}}/> {t('propriete.labels.supprimerTousLesPhotos')}
                        </Button>
                        <ImageList sx={{ maxHeight: 500 }} cols={3} rowHeight={164}>
                            {imageList.map((image, index) => (
                                <ImageListItem key={index}>
                                    <img
                                        src={`${image['data_url']}}`}
                                        srcSet={`${image['data_url']}`}
                                        alt=""
                                        loading="lazy"
                                    />
                                    <div className="image-item__btn-wrapper">
                                        <Button
                                            variant="outlined"
                                            onClick={() => onImageUpdate(index)}
                                            className={classes.changeImage}
                                        >
                                            {t('propriete.labels.changer')}

                                        </Button>
                                    
                                        <Button 
                                            variant="outlined"
                                            style={{'fill': '#d04343', color: '#d04343'}}
                                            onClick={() => onImageRemove(index)}
                                        >
                                            <Delete/>
                                        </Button>
                                    </div>
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </div>
                )}
            </ImageUploading>
            
        </>
    )
}
